import { CSSProperties } from "react";
import styles from "./Loading.module.css";

type LoadingProps = {
  visible: boolean;
  style?: CSSProperties;
};

function Loading({ visible, style }: LoadingProps) {
  return <>{visible && <div className={styles.loader} style={{ ...style }} />}</>;
}

export default Loading;
